import { BrokenVase, Legal } from '@insify/design-system/line-icons';
import { useTranslation } from 'react-i18next';

import { useCoverageOptions } from '../pages/Coverages/userCoverageOptions';

import { useParamsQuery, usePricingQuery } from './useQueries';

import type { AddOnProps } from '@insify/funnel-components';

export const useAddOns = (): AddOnProps[] => {
  const { data: pricingData } = usePricingQuery();
  const { publicLiabilityOptions, legalProtectionOptions } = useCoverageOptions();
  const { data: paramsData } = useParamsQuery();
  const { t } = useTranslation(['funnel']);

  const addOns: AddOnProps[] = [
    {
      id: 'publicLiability',
      name: 'publicLiability',
      description: t('funnel:add_on_public_liability_description'),
      icon: <BrokenVase />,
      priceAmount:
        pricingData?.publicLiability?.totalPayable.cents !== '0'
          ? pricingData?.publicLiability?.totalPayable
          : undefined,
      afterPrice: t('funnel:add_on_public_liability_after_price'),
      title: t('funnel:add_on_public_liability_title'),
      collapsibleProps: {
        description: t('funnel:add_on_public_liability_collapsible_content'),
        coverageAmount: publicLiabilityOptions.enabled.coverLimit,
        coverageAmountSubtext: t('funnel:add_on_public_liability_coverage_amount_subtext'),
      },
      collabsibleAnchor: t('coverage_show_detail_button'),
    },
  ];

  if (paramsData?.legalProtection) {
    addOns.unshift({
      id: 'legalProtection',
      name: 'legalProtection',
      description: t('funnel:add_on_legal_protection_description'),
      icon: <Legal />,
      included: true,
      priceDisplay: t('funnel:receipt_included'),
      title: t('funnel:add_on_legal_protection_title'),
      collapsibleProps: {
        coverageAmount: legalProtectionOptions.enabled.coverLimit,
        coverageAmountSubtext: t('funnel:add_on_legal_protection_coverage_amount_subtext'),
      },
      collabsibleAnchor: t('coverage_show_detail_button'),
    });
  }

  return addOns;
};
